import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/auth/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class LoginFormComponent {
  loginForm: FormGroup;
  isLoading: boolean = false;
  showPassword: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
      password: [
        '',
        [
          Validators.required,
          // Validators.pattern(/^(?=.*[A-Z])(?=.*[0-9]).{7,12}$/),
        ],
      ],
    });
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
  handleLogin() {
    if (this.loginForm.valid) {
      this.isLoading = true;
      const { username, password } = this.loginForm.value;
      this.authService.login(username!, password!)
        .pipe(
          tap((response) => {
            localStorage.setItem('token', response.token);
            localStorage.setItem('refresh_token', response.refresh_token);
          }),
          switchMap(() => this.authService.getUserInfo()),
          tap((response) => {
            localStorage.setItem('userRole', JSON.stringify(response.role));
            localStorage.setItem('email', JSON.stringify(response.email));
          })
        )
        .subscribe({
          next: () => {
            this.router.navigate(['/home/dashboard']);
            this.isLoading = false;
          },
          error: (error) => {
            this.isLoading = false;
            this.handleLoginError(error);
            console.error('Login failed', error);
          },
        });
    } else {
      this.handleLoginError({ status: -1 });
    }
  }

  handleLoginError(error: any) {
    let message =
      'Ha ocurrido un error. Por favor, inténtelo de nuevo más tarde.';
    if (error.status === 401) {
      message =
        'Usuario o contraseña incorrectos. Por favor, inténtelo de nuevo.';
    } else if (error.status === 404) {
      message =
        'El servidor no pudo encontrar la página solicitada. Por favor, inténtelo de nuevo más tarde.';
    } else if (error.status === -1) {
      message = 'Por favor, complete todos los campos correctamente.';
    }

    Swal.fire({
      text: message,
      icon: 'error',
      confirmButtonText: 'OK',
      confirmButtonColor: '#ff0000',
    });
  }
}

